'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'
import ReactDOM from 'react-dom'
import { useFormikContext } from 'formik'

// walrus
import Text from '@components/kit/text'
import Box from '@components/kit/box'
import { SelectButton, SelectMenu, useSelect } from '@components/kit/select'
import Form, { SubmitButton, CheckBoxListField } from '@components/kit/form'

/* -----------------------------------------------------------------------------
 * ReportsFilterSelect
 * -------------------------------------------------------------------------- */

// options are read by `name` plus whichever key `idKey` points at, so any
// shape carrying both works: redux users/companies or dashboard-derived rows
type FilterOption = { name: string } & Record<string, any>

type ReportsFilterSelectProps = {
  idKey: string
  name: string
  label: string
  filterOptions: Record<string, FilterOption> | FilterOption[]
}

const ReportsFilterSelect = ({
  idKey,
  name,
  label,
  filterOptions
}: ReportsFilterSelectProps) => {
  const buttonRef = React.useRef(null)
  const menuRef = React.useRef(null)
  const options = Object.values(filterOptions)

  const { handleSubmit } = useFormikContext()
  const { getToggleButtonProps, getMenuProps, closeMenu } = useSelect({
    buttonRef,
    menuRef,
    items: options
  })

  const handleSubmitButtonPress = () => {
    handleSubmit()
    closeMenu()
  }

  return (
    <>
      <Box ref={buttonRef} width='100%' height='48'>
        <SelectButton
          {...getToggleButtonProps()}
          width='10'
          height='10'
          px='16'
          py='00'
          size='medium'
          bg='white'
          fill='purple'
        >
          <Text fontSize={12} textColor='purple' fontWeight='bold'>
            {label}
          </Text>
        </SelectButton>
      </Box>
      {ReactDOM.createPortal(
        <SelectMenu {...getMenuProps({ ref: menuRef })} minWidth='220px'>
          <Form mt='-12'>
            {options.length > 0 &&
              options.map((option, index) => (
                <React.Fragment key={index}>
                  <Box mt='12'>
                    <CheckBoxListField
                      label={option.name}
                      name={name}
                      value={option[idKey]}
                    />
                  </Box>
                </React.Fragment>
              ))}
            <SubmitButton
              size='small'
              mt='12'
              onPress={handleSubmitButtonPress}
            >
              Filter
            </SubmitButton>
          </Form>
        </SelectMenu>,
        document.getElementById('root')
      )}
    </>
  )
}

export default ReportsFilterSelect
